import { FRONTEND_ENTERPRISE_APP_URLS } from './constants';

export type TEnterpriseSwitchAccountUrlParams = {
  companyId: number | string;
  corporationId?: number | string;
  redirectTo?: string;
};

export class EnterpriseSwitchAccountUrlHelper {
  static getUrl({
    companyId,
    corporationId,
    redirectTo,
  }: Readonly<TEnterpriseSwitchAccountUrlParams>): string {
    const enterpriseBaseUrl =
      FRONTEND_ENTERPRISE_APP_URLS[process.env.NEXT_PUBLIC_CLIENT_ENV] ??
      FRONTEND_ENTERPRISE_APP_URLS.development;

    const query = new URLSearchParams({ companyId: String(companyId) });
    if (corporationId !== undefined) {
      query.set('corporationId', String(corporationId));
    }
    if (redirectTo) {
      query.set('redirectTo', redirectTo);
    }

    return `${enterpriseBaseUrl}/auth/switch-account?${query.toString()}`;
  }
}
